import { omit } from 'lodash'
import { create } from 'zustand'

type AutoEarnStore = {
  awaitingPendingStates: Record<string, boolean>
  setAwaitingPendingState: (
    smartAccountId: string,
    enabled: boolean | undefined,
  ) => void
}

// Account ids with a just-submitted auto-earn txn the transactions query
// doesn't report as pending yet
export const useAutoEarnStore = create<AutoEarnStore>((set) => ({
  awaitingPendingStates: {},
  setAwaitingPendingState: (smartAccountId, enabled) =>
    set((state) => ({
      awaitingPendingStates:
        enabled === undefined
          ? omit(state.awaitingPendingStates, smartAccountId)
          : { ...state.awaitingPendingStates, [smartAccountId]: enabled },
    })),
}))
